import { render, staticRenderFns } from "./CustomUnit.vue?vue&type=template&id=b540d684&"
import script from "./CustomUnit.vue?vue&type=script&lang=js&"
export * from "./CustomUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports